import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData,
  type GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetError,
  type GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponse,
  getRetailerRegionV1RetailerRegionsRetailerRegionIdGet,
} from '../../generated';

export type GetRetailerRegionQueryVariables = GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData['path'];

export type GetRetailerRegionQuery = GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponse;

export const useGetRetailerRegionQuery = <
  TData = GetRetailerRegionQuery,
  TError = GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetError,
>(
  { retailer_region_id }: GetRetailerRegionQueryVariables,
  options?: Omit<UseQueryOptions<GetRetailerRegionQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetRetailerRegionQuery, TError, TData>({
    queryKey: ['GetRetailerRegion', { retailer_region_id }],
    queryFn: async () => {
      const { data } = await getRetailerRegionV1RetailerRegionsRetailerRegionIdGet({
        path: { retailer_region_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetRetailerRegionQuery.getKey = ({ retailer_region_id }: GetRetailerRegionQueryVariables) => [
  'GetRetailerRegion',
  { retailer_region_id },
];

useGetRetailerRegionQuery.fetcher = (
  { retailer_region_id }: GetRetailerRegionQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getRetailerRegionV1RetailerRegionsRetailerRegionIdGet({
      path: { retailer_region_id },
      throwOnError: true,
    });
    return data;
  };
};
